export const permissions: any = {
    "PRE_CERTIFICATION_SAVE_CALCULATOR": { "id": "c13bfe8f-31c2-4d9e-9a3b-7717df1f10bb" },
    "PRE_CERTIFICATION_DOWNLOAD_ALL_S2": { "id": "ae4cf51e-fb0d-4915-87eb-01af0cbc3e99" },
    "PRE_CERTIFICATION_UPDATE_S2_STATUS": { "id": "5dc40d16-d067-4b7a-8f81-81ca9891d45a" },
    "PRE_CERTIFICATION_SAVE_OVERVIEW": { "id": "d0d3d55a-3e7d-4f09-a84b-af1738629078" },
    "PRE_CERTIFICATION_UPLOAD_OPERATION_CREDIT": { "id": "bb85b51a-75e5-4e1e-a271-95a5f26bb6f1" },
    "PRE_CERTIFICATION_ADD_COMMENT_S2": { "id": "23e2ecac-e3aa-4f65-a8cb-e64b552f7d2d" },
    "PRE_CERTIFICATION_VIEW_ACTIVITY": { "id": "f3a400b9-ccfa-4dc1-a00a-a50a79c42d68" },
    "PRE_CERTIFICATION_UPLOAD_S6_PERFORMA": { "id": "4cdedc7b-d7f6-4b47-a0ef-0574f379eaba" },
    "PRE_CERTIFICATION_DOWNLOAD_PERFORMA": { "id": "476c5ab3-1ee8-4cf6-98db-2eedd1307fa1" },
    "PRE_CERTIFICATION_VIEW_PERFORMA": { "id": "a33b9b52-0649-4554-a1d4-6d81423ecdf8" },
    "PRE_CERTIFICATION_UPLOAD_TAX_INVOICE": { "id": "3a5e4cd1-bbef-4ddc-ac7d-6f30b6fb10df" },
    "PRE_CERTIFICATION_DOWNLOAD_TAX_INVOICE": { "id": "0d4c8817-84b7-42f2-aa3f-e4f1f9fefadb" },
    "PRE_CERTIFICATION_VIEW_TAX_INVOICE": { "id": "3fd68342-902a-4bc0-8b4e-d1c879e359d8" },
    "PRE_CERTIFICATION_UPLOAD_CERTIFICATION": { "id": "cb4b8d91-7b6c-4e52-a1e3-bad5de1e8a48" },
    "PRE_CERTIFICATION_DOWNLOAD_CERTIFICATION": { "id": "26c5ef3d-b6a1-4c35-8e61-e76a5019b44a" },
    "PRE_CERTIFICATION_VIEW_CERTIFICATION": { "id": "7690bb46-9422-4ac8-8664-58459fbbe076" },

    "CERTIFICATION_UPLOAD_S6_PERFORMA": { "id": "09251213-433b-4128-944b-503f17a4eadc" },
    "CERTIFICATION_DOWNLOAD_PERFORMA": { "id": "26c143b2-5602-4e95-b57c-d15ce15f2741" },
    "CERTIFICATION_VIEW_PERFORMA": { "id": "ff26db05-8906-4ab5-952e-23496f06ed3f" },
    "CERTIFICATION_UPLOAD_TAX_INVOICE": { "id": "10415cac-c1f8-450b-8eaa-f17a7383282d" },
    "CERTIFICATION_DOWNLOAD_TAX_INVOICE": { "id": "cbfc45a1-1be6-48bd-b745-62b5a8218769" },
    "CERTIFICATION_VIEW_TAX_INVOICE": { "id": "1ce05154-d15a-4111-96c6-78290021bb40" },
    "CERTIFICATION_UPLOAD_CERTIFICATION": { "id": "389cf684-952b-4383-be5d-b79cb6a9b20b" },
    "CERTIFICATION_DOWNLOAD_CERTIFICATION": { "id": "9fa9099b-de8f-4721-86d8-1def24181689" },
    "CERTIFICATION_VIEW_CERTIFICATION": { "id": "09e9ecce-cf18-4158-bd78-1dd1487fcc3a" },

    "DASHBOARD_VIEW_DASHBOARD": { "id": "478219d1-a443-4137-a32d-ce9877f94b1f" },
    "DASHBOARD_SHOW_ADD": { "id": "cc863425-e061-4d6d-ab8a-c2dbe3da7eac" },
    "DASHBOARD_ADD_PROJECT": { "id": "e0d54f56-703f-4a63-8d41-d623c069c20b" },
    "DASHBOARD_ADD_NEW_TASK": { "id": "8c3cf5f8-13c7-4058-9695-9cc9ebf4a7df" },
    "DASHBOARD_ADD_CONSULTANT": { "id": 'b7fbd9c0-191e-4fce-b8d1-4c649b3c59d2' },
    "DASHBOARD_VIEW_MY_TASK": { "id": '3ce30e8c-202c-4eae-94ba-f27d5b221238' },
    "DASHBOARD_VIEW_TOP_GREEN_MATERIAL_VENDOR": { "id": '3684f733-9a00-4949-914f-86cf7fd2844b' },
    // Green Materials / Vendor (migrations 20261013, 20261016, 20261027). View List was retired by 20261027.
    "GREEN_MATERIALS_ALL": { "id": "501c205a-749d-465e-8998-43d02e4e3ad7" },
    "GREEN_MATERIALS_EDIT": { "id": "d8218bb0-aeeb-4bc7-a9a8-0bde7c4c9ba1" },
    "GREEN_MATERIALS_APPROVE_RESPONSE": { "id": "efcc3fa6-c657-44c9-bb36-c4f988b2c0c6" },
    "GREEN_MATERIALS_READ_ONLY": { "id": "7bad3ecf-b2c3-412e-a1f3-4a0104aeb28b" },
    "VENDOR_ALL": { "id": "21f43124-b49c-49ec-8015-a6efd477170f" },
    "VENDOR_EDIT": { "id": "ca2d36b6-4d4f-402f-bedf-3d83e0cd1299" },
    "VENDOR_APPROVE_RESPONSE": { "id": "729d575d-558f-4a7b-b87d-7d15c907112d" },
    "VENDOR_READ_ONLY": { "id": "9186d052-a7c3-4cc6-a994-ff29bd8a28cb" },
    "DASHBOARD_VIEW_NOTIFICATION": { "id": '53e9e54c-be77-429c-b626-a128c58207dc' },
    "DASHBOARD_CALENDAR": { "id": 'd5ca630b-d1a0-4e38-a998-30e79d0b7c1d' },
    "DASHBOARD_ACTIVITY_LOG": { "id": 'b5924f50-7644-41ca-b8be-a64c6cc8cf7b' },

    "PROJECT_VIEW_PROJECT_LIST": { "id": "6c71a35d-2226-4353-b783-6a1020784def" },

    "MEMBERSHIP_ADD": { "id": "b846fd31-512a-42e6-9342-913547799822" },
    "MEMBERSHIP_UPDATE": { "id": "72d4e486-1cb2-4c1a-b672-fffefe9642f6" },
    "MEMBERSHIP_UPLOAD_PERFORMA_INVOICE": { "id": "afe1aaab-e7cd-49e9-bad3-fabc77e872ef" },
    "MEMBERSHIP_UPLOAD_RECEIPT": { "id": "3829e065-e22d-4cab-96ec-2995294c8c69" },

    "REGISTRATION_UPLOAD_PERFORMA_INVOICE": { "id": "4a19e964-a361-4d27-9f9a-1e7affec7e88" },
    "REGISTRATION_UPLOAD_RECEIPT": { "id": "c06cb085-fcfe-4a89-8a1f-611dd41f55db" },
    "REGISTRATION_ADD": { "id": "b4a8214c-49f6-46b7-8585-4c2a6f53c8b9" },
    "REGISTRATION_DOWNLOAD": { "id": "b67957de-d40a-4096-87a5-e1f8618ad802" },

    "SIX_MONTHLY_PREVIEW_SIX_MONTHLY": { "id": "14bf5422-e352-4320-bcde-36736743ecdf" },
    "SIX_MONTHLY_DOWNLOAD_REPORT": { "id": "f8baa427-64a6-479c-b627-01bb82eb4dcf" },
    "SIX_MONTHLY_UPDATE_STATUS": { "id": "d8dc3e06-9b3e-469b-8921-93e737f22c98" },
    "SIX_MONTHLY_ADD_DESCRIPTION": { "id": "66e4d65c-aa59-47cd-8af2-37b21003d0eb" },
    "SIX_MONTHLY_ADD_IMAGE": { "id": "504b2f52-4d84-44ef-b74c-d6b15e9cb68d" },
    "SIX_MONTHLY_ADD_COMMENT": { "id": "c5e671f4-64f7-43d1-8a63-282efccdb201" },
    "SIX_MONTHLY_VIEW_COMMENT": { "id": "9cb8eecd-9ef3-45af-9b99-72c653abd145" },
    "SIX_MONTHLY_ADD_DOCUMENTS": { "id": "7b42f2f1-7251-4a58-92f0-5592c7e814ae" },

    "CERTIFICATION_ADD_INPUT_CHECKLIST": { "id": "d1b73b24-50b5-4da3-b0aa-ae910206a2df" },
    "CERTIFICATION_UPDATE_S1_STATUS": { "id": "74d0038d-e41a-4ec1-861d-3b6cdedd114f" },
    "CERTIFICATION_UPLOAD_S_ONE": { "id": "11f536f8-2bb6-42c9-b00f-15cbbdfd0c17" },
    "CERTIFICATION_DOWNLOAD_S_ONE": { "id": "26392971-26ab-41c2-a30b-7020502ff9e4" },
    "CERTIFICATION_VIEW_S_ONE": { "id": "dc98233c-b86f-457c-be60-246b04770557" },
    "CERTIFICATION_ADD_COMMENT_S_ONE": { "id": "cde60c9e-b484-4168-af60-85e55978a803" },
    "CERTIFICATION_ADD_GUILD": { "id": "1c5018c8-6f49-48e8-96e5-3a9b5cc0822d" },

    "CLIENT_LIST_VIEW_CLIENT_LIST": { "id": "40cade2e-90e7-430f-9526-a16cd3a2c8dc" },

    "USER_MANAGEMENT_VIEW_USER_LIST": { "id": "1393be29-3c2e-40f1-b536-7396c91b7f78" },
    "USER_MANAGEMENT_ADD_USER": { "id": "f4738fd6-7fb9-4975-b1cb-8604eda79366" },

    "CONSULTANTS_VIEW_CONSULTANTS": { "id": "260223e0-6d67-4a74-8182-f8bdea713c81" },

    "PRE_CERTIFICATION_UPLOAD_S_ONE": { "id": "e7660c13-21ec-426d-893f-62eea5ce3f43" },
    "PRE_CERTIFICATION_DOWNLOAD_S_ONE": { "id": "3ff0321e-c4c2-4dd3-afbd-8cf8f57bd7b2" },
    "PRE_CERTIFICATION_ADD_GUILD": { "id": "6df685ab-5037-4154-86a7-c464d24bafd6" },

    "CERTIFICATION_SAVE_CALCULATOR": { "id": "7121c6cd-ef18-414d-92e9-fbea078ce946" },
    "CERTIFICATION_DOWNLOAD_ALL_S2": { "id": "15da25f1-58ee-4aca-ab01-67fd86ee4b1d" },

    "CALENDAR_VIEW_CALENDAR": { "id": "ce140789-744a-4d49-b30b-7756d7437b07" },
    "CALENDAR_ADD_EVENT": { "id": "60a56554-84da-40b4-a094-848047a3d68b" },

    "USER_ACTIVITY_VIEW_USER_ACTIVITY": { "id": "2519fc5e-3d61-4f82-8e19-a28c151b406c" },

    "PROFILE_VIEW_PROFILE": { "id": "a3f2e5a2-4069-4537-ad89-fa8983c14e92" },

    "CERTIFICATION_MASTER_VIEW_LIST": { "id": "29baeb90-f148-48f5-ba76-2bf9ae315c9f" },
    "CERTIFICATION_MASTER_ADD": { "id": "4d69c57b-7cc2-470e-ba44-7ec5c3e93598" },
    "CERTIFICATION_MASTER_UPDATE": { "id": "8280185e-0550-4506-a4cc-236f2818836c" },
    "CERTIFICATION_MASTER_ENABLE_DISABLE": { "id": "5df271d8-cef0-4ad1-83db-f66a69d983f7" },

    "CATEGORY_ONE_ADD": { "id": "2ca79276-1ef7-44e6-b429-90cde4e54af4" },
    "CATEGORY_ONE_VIEW_LIST": { "id": "f290180c-1b7e-47a9-b339-05a155d5b241" },
    "CATEGORY_ONE_UPDATE": { "id": "e67f4362-dea1-4826-b5ea-c7c7f23917ca" },
    "CATEGORY_ONE_ENABLE_DISABLE": { "id": "2acb11ca-8d80-4093-94cb-eb56019d0b20" },

    "TYPOLOGY_VIEW_LIST": { "id": "08c332cc-b44f-4018-8142-e3efdda484ee" },
    "TYPOLOGY_ADD": { "id": "8cbd16f8-cb86-4be6-b0c0-7397673599d2" },
    "TYPOLOGY_UPDATE": { "id": "c479f0d0-078a-45cd-a6f8-8b76d488c40b" },
    "TYPOLOGY_ENABLE_DISABLE": { "id": "e6453a76-8eea-45ed-8b5b-bd72f1f27273" },

    "MASTER": { "id": "14e67fcb-fc60-4852-bf91-3b4e8511089a" },

    "SUB_CATEGORY_VIEW_LIST": { "id": "7faa6d5b-6ec6-4644-bbc8-58eab59741a1" },
    "SUB_CATEGORY_ADD": { "id": "0f2786dd-d302-4359-84ad-f612e055ced5" },
    "SUB_CATEGORY_UPDATE": { "id": "67712d3d-8fe1-4db2-8e75-8f8f326c3c06" },
    "SUB_CATEGORY_ENABLE_DISABLE": { "id": "9057d6ee-75cf-4fcf-b676-97cd13413b80" },

    "CATEGORY_DOCUMENTS_VIEW_LIST": { "id": "c973c0f6-f8ab-4cea-b0a4-c5a116fc7b50" },
    "CATEGORY_DOCUMENTS_ADD": { "id": "5e3277a8-845f-44ab-9203-06fc33ea692d" },
    "CATEGORY_DOCUMENTS_UPDATE": { "id": "1f3de77d-b088-4b9a-a68e-5bbb6794dcb9" },
    "CATEGORY_DOCUMENTS_ENABLE_DISABLE": { "id": "67ecb13b-0931-4e32-b880-8d618345dfaf" },

    "INPUT_CHECKLIST_VIEW_LIST": { "id": "693bc138-6627-449b-9b71-5a3c9006adbe" },
    "INPUT_CHECKLIST_ADD_INPUT_CHECKLIST": { "id": "9cad836d-2aeb-4fcb-9133-75d2228db764" },
    "INPUT_CHECKLIST_EDIT_INPUT_CHECKLIST": { "id": "9e8dbd37-312c-4582-a50a-62bc92ef2ba6" },

    "PRE_CERTIFICATION_ADD_INPUT_CHECKLIST": { "id": "d1434022-f27f-420b-a5b7-d6d39c508d09" },
    "PRE_CERTIFICATION_UPDATE_S1_STATUS": { "id": "02ef8fc9-4aeb-4049-a892-a62f13f0b9bb" },
    "PRE_CERTIFICATION_VIEW_S_ONE": { "id": "bec9b9de-f108-47f8-b035-6dd837e5dd06" },
    "PRE_CERTIFICATION_ADD_COMMENT_S_ONE": { "id": "d9e38e52-5b9b-4e71-917c-8b6ba252f1b2" },

    "CERTIFICATION_UPDATE_S2_STATUS": { "id": "e30af9a0-b047-4bd2-95a3-6a8b0904a344" },
    "CERTIFICATION_SAVE_OVERVIEW": { "id": "fcd3183c-685a-43a8-9cb0-8e0de90cdbf2" },
    "CERTIFICATION_UPLOAD_OPERATION_CREDIT": { "id": "8f78cc1a-54fc-4b0a-a56a-87be8c08bc0d" },
    "CERTIFICATION_ADD_COMMENT_S2": { "id": "083b8744-fa43-4833-b6c8-7e7b90748c58" },

    "CERTIFICATION_VIEW_ACTIVITY": { "id": "bfb35ba9-0fd0-4780-a7a9-1bede6c1f8ad" },

    "CATEGORY_VIEW_LIST": { "id": "45cb1451-3d47-4e00-b16a-064f3243f372" },
    "CATEGORY_ADD": { "id": "01d0ed68-85b3-4f27-92ae-9ae1d661869b" },
    "CATEGORY_UPDATE": { "id": "a3111434-af13-4360-a504-a532ff67b6d6" },
    "CATEGORY_ENABLE_DISABLE": { "id": "dc4f1763-54be-4593-811f-521b45195952" },

    "SERVICE_LEVEL_VIEW_LIST": { "id": "2db3ed58-7ad7-442e-a5d1-020b47853b16" },
    "SERVICE_LEVEL_ADD": { "id": "d2eb44dc-5eeb-428b-bcc9-588fa3d36d4b" },
    "SERVICE_LEVEL_UPDATE": { "id": "53c9333b-b624-49a8-b418-f1af3408ff2c" },
    "SERVICE_LEVEL_ENABLE_DISABLE": { "id": "69319935-4e8a-44ce-8de1-d42c54fd4f92" },

    "UNIT_MASTER_VIEW_LIST": { "id": "37ec05f6-08e8-4e55-8029-7f7674ff34fa" },
    "UNIT_MASTER_ADD": { "id": "12dcd33c-52ba-4a4a-a4ca-1e6ffe1d59f0" },
    "UNIT_MASTER_UPDATE": { "id": "f0c9d82a-c507-4782-8cf4-f9f062cd6591" },
    "UNIT_MASTER_ENABLE_DISABLE": { "id": "b75f00a6-bcd2-42a0-8bfe-3ae37b28409d" }
}



// Menu items open to every signed-in user, whatever their role
export const ALL_USERS_PERMISSION = 'ALL_USERS';
